import { connect } from 'react-redux'
import WealthBreakdown from './wealth-breakdown'

function mapStateToProps(state) {
  return {

    totalContributionsTaxable: state.totalContributionsTaxable,
    totalContributionsNonTaxable: state.totalContributionsNonTaxable,
    totalTaxable: state.totalTaxable,
    totalNonTaxable: state.totalNonTaxable,
  }
}

export default connect(mapStateToProps, {})(WealthBreakdown)

// export default function (component) {
//   return connect(mapStateToProps, mapDispatchToProps)(component)


// WEBPACK FOOTER //
// ./sections/wealth-breakdown/wealth-breakdown-container.js